<template>
  <!-- 添加一个场景页面 -->
  <!-- 设置页面的内容区域 -->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">
      <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->

      <config-title-hang>
        <span slot="config_title_hang_ele2">场景参数设置</span>
        <span
          v-if="OneSceneinfo.sceneId != '' "
          slot="config_title_hang_ele5"
          @click="relevantDeviceBtnHandle"
        >关联的设备</span>
      </config-title-hang>

      <config-hang>
        <span slot="config_hang_ele2">场景名称</span>
        <!-- img和input 配套使用 点击可以触发input的聚焦事件  v-model实际上是直接绑定的仓库数据信息 -->
        <img slot="config_hang_xiugai" src="~assets/img/config/xiugai.png" alt />
        <input
          type="text"
          slot="config_hang_input_right"
          id="xiugaiName"
          placeholder="请输入场景名称"
          v-model="OneSceneinfo.sceneName"
        />
      </config-hang>

      <config-hang @click.native="xuanImgBtnHandle">
        <span slot="config_hang_ele2">场景按钮图片</span>
        <img slot="config_hang_xuanimg" :src="computerSceneIconSrc" alt />
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>

      <config-hang @click.native="xuanRegionBtnHandle">
        <span slot="config_hang_ele2">场景区域</span>
        <span slot="config_hang_ele3">{{OneSceneinfo.regionName}}</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>

      <config-hang :switchState="OneSceneinfo.deleteState" @click.native="showifBtnHandle">
        <span slot="config_hang_ele2">场景是否显示</span>
        <img slot="config_hang_switchBtn_open" src="~assets/img/config/zhu_kai.png" alt />
        <img slot="config_hang_switchBtn_close" src="~assets/img/config/zhu_guan.png" alt />
      </config-hang>

      <config-title-hang
        v-if="OneSceneinfo.sceneId != '' "
        class="config_add_scene_title_hang_height"
      >
        <span slot="config_title_hang_ele2"></span>
      </config-title-hang>

      <config-hang v-if="OneSceneinfo.sceneId != '' " @click.native="xiuGaiOneSceneRuleBtnHandle">
        <span slot="config_hang_ele2">执行逻辑设置</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>

      <config-title-hang
        v-if="OneSceneinfo.sceneId != '' "
        class="config_add_scene_title_hang_height"
      >
        <span slot="config_title_hang_ele2"></span>
      </config-title-hang>

      <div
        v-if="OneSceneinfo.sceneId != '' "
        class="public_config_que_ren_btn"
        @click="configXiuGaiQueRenBtn"
      >保存并返回</div>
      <div v-else class="public_config_que_ren_btn" @click="configQueRenBtn">下一步</div>
    </div>
  </div>
</template>

<script>
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";
export default {
  data() {
    return {
      OneSceneinfo: {
        ////虚拟的一个场景仓库信息，实际在页面加载过程中指向了仓库
        deleteState: 1,
        followState: null,
        iconId: "",
        iconUrl: "",
        regionId: "",
        regionName: "请选择一个区域",
        sceneId: "",
        sceneName: "",
        sceneNo: null
      }
    };
  },
  computed: {
    computerSceneIconSrc() {
      ////计算选择区域图片应该显示的按钮
      // console.log(this.OneSceneinfo.iconUrl);
      if (this.OneSceneinfo.iconUrl === "") {
        ///动态绑定图片 需要require
        return require("assets/img/config/xuanimg.png");
      } else {
        ////动态绑定http的url  不需要require
        return this.OneSceneinfo.iconUrl;
      }
    }
  },
  components: {
    configHang,
    configTitleHang
  },
  methods: {
    showifBtnHandle() {
      // 对象是否显示按钮按下了
      if (this.OneSceneinfo.deleteState === 1) {
        this.OneSceneinfo.deleteState = 0;
      } else {
        this.OneSceneinfo.deleteState = 1;
      }
    },
    configQueRenBtn() {
      // 新增加一个场景的下一步按钮按下了
      // 提交服务器之前对数据进行检查;
      if (this.OneSceneinfo.sceneName === "") {
        this.$toast("请输入场景名称~");
        return;
      } else if (this.OneSceneinfo.iconId === "") {
        this.$toast("请选择场景图标~");
        return;
      } else if (this.OneSceneinfo.regionId === "") {
        this.$toast("请选择场景区域~");
        return;
      }
      ////20200418补BUG限制场景名称长度的提示
      if (this.OneSceneinfo.sceneName.length > 20) {
        this.$toast("修改失败，名称不能超过20个字符哦~");
        return;

      }
      //添加一个新场景的接口
      this.$request({
        method: "post",
        url: "/userScene/saveUserScene",
        data: {
          token: this.$store.state.token,
          iconId: this.OneSceneinfo.iconId,
          deleteState: this.OneSceneinfo.deleteState,
          sceneName: this.OneSceneinfo.sceneName,
          regionId: this.OneSceneinfo.regionId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            console.log(res.data);
            this.OneSceneinfo.sceneId = res.data.data.sceneId; ////拿到服务器返回的数据结果 场景id  存到仓库
            // this.$showTipsToast(1, "获取成功", true); ////提示框
            /// 请求场景对应的规则信息接口，获取数据
            this.$request({
              method: "post",
              url: "/userScene/findUserSceneRuleListById",
              data: {
                token: this.$store.state.token,
                sceneId: this.OneSceneinfo.sceneId
              }
            })
              .then(res => {
                if (res.data.code != 0) {
                  this.$showTipsToast(3, res.data.message);
                  ////说明信息填写错误,控制失败了，
                  return;
                } else {
                  ////、控制成功了
                  // this.ServeSceneRule = res.data.data; ////拿到服务器返回的数据结果
                  this.$store.dispatch(
                    "asyUpdataOneSceneRuleList",
                    res.data.data
                  ); ////把服务器获取到的规则列表地址存到仓库
                  // this.$showTipsToast(1, "获取成功", true); ////提示框
                  //// 提交完服务器的数据到仓库之后在 请求页面跳转。避免出现数据还没请求到，页面已经渲染完的空白页面。
                  this.$router.push("ConfigAddSceneRule");
                }
              })
              .catch(error => {
                console.log(error);
              });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    xuanRegionBtnHandle() {
      // 选择区域的按钮按下了
      ///需要传递一个 区域的类型  要传入的参数类型  0:产品 1:场景 2:对象
      this.$router.push({ path: "/SelectRegion", query: { type: 1 } });
      // this.$router.push("/SelectRegion");
    },
    xuanImgBtnHandle() {
      // 选择img的按钮按下了
      ///需要传递一个 img类型列表  要传入图片的类型  0:产品 1:场景 2:对象
      this.$router.push({ path: "/SelectIcon", query: { type: 1 } });
    },
    configXiuGaiQueRenBtn() {
      // 修改一个场景的基础信息按钮按下了
      // 提交服务器之前对数据进行检查;
      if (this.OneSceneinfo.sceneName === "") {
        this.$toast("请输入场景名称~");
        return;
      } else if (this.OneSceneinfo.iconId === "") {
        this.$toast("请选择场景图标~");
        return;
      } else if (this.OneSceneinfo.regionId === "") {
        this.$toast("请选择场景区域~");
        return;
      }
        // console.log
      ////20200418补BUG限制场景名称长度的提示
      if (this.OneSceneinfo.sceneName.length > 20) {
        this.$toast("修改失败，名称不能超过20个字符哦~");
        return;

      }

      //修改场景信息接口
      this.$request({
        method: "post",
        url: "/userScene/updateUserSceneById",
        data: {
          token: this.$store.state.token,
          sceneId: this.OneSceneinfo.sceneId,
          iconId: this.OneSceneinfo.iconId,
          deleteState: this.OneSceneinfo.deleteState,
          sceneName: this.OneSceneinfo.sceneName,
          regionId: this.OneSceneinfo.regionId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            console.log(res.data);
            // this.OneSceneinfo.sceneId = res.data.data.sceneId; ////拿到服务器返回的数据结果 场景id  存到仓库
            this.$showTipsToast(1, "修改成功", true); ////提示框
            this.$router.go(-1);
            // this.$router.push("ConfigSceneManage");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    xiuGaiOneSceneRuleBtnHandle() {
      // 20200328补BUG，用户点执行逻辑的时候需要先保存一下基本的信息，然后在进行跳转执行逻辑页面
      // 修改一个场景的基础信息按钮按下了
      // 提交服务器之前对数据进行检查;
      if (this.OneSceneinfo.sceneName === "") {
        this.$toast("请输入场景名称~");
        return;
      } else if (this.OneSceneinfo.iconId === "") {
        this.$toast("请选择场景图标~");
        return;
      } else if (this.OneSceneinfo.regionId === "") {
        this.$toast("请选择场景区域~");
        return;
      }

      //修改场景信息接口
      this.$request({
        method: "post",
        url: "/userScene/updateUserSceneById",
        data: {
          token: this.$store.state.token,
          sceneId: this.OneSceneinfo.sceneId,
          iconId: this.OneSceneinfo.iconId,
          deleteState: this.OneSceneinfo.deleteState,
          sceneName: this.OneSceneinfo.sceneName,
          regionId: this.OneSceneinfo.regionId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            console.log(res.data);
          }
        })
        .catch(error => {
          console.log(error);
        });

      /// 请求场景对应的规则信息接口，获取数据
      this.$request({
        method: "post",
        url: "/userScene/findUserSceneRuleListById",
        data: {
          token: this.$store.state.token,
          sceneId: this.OneSceneinfo.sceneId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.ServeSceneRule = res.data.data; ////拿到服务器返回的数据结果
            this.$store.dispatch("asyUpdataOneSceneRuleList", res.data.data); ////把服务器获取到的规则列表地址存到仓库
            // this.$showTipsToast(1, "获取成功", true); ////提示框
            //// 提交完服务器的数据到仓库之后在 请求页面跳转。避免出现数据还没请求到，页面已经渲染完的空白页面。
            this.$router.push("ConfigAddSceneRule");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    relevantDeviceBtnHandle() {
      /////关联的设备按钮按下了
      /// 获取场景关联设备接口，获取数据
      this.$request({
        method: "post",
        url: "/userScene/findDeviceListBySceneId",
        data: {
          token: this.$store.state.token,
          sceneId: this.OneSceneinfo.sceneId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.ServeSceneRule = res.data.data; ////拿到服务器返回的数据结果
            this.$showTipsToast(6, res.data.data);
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    console.log("mounted阶段");
  },
  created() {
    console.log("created阶段");

    //// 把仓库的一个场景信息的地址拿过来  拿的是地址  并不是数据
    console.log(this.$store.state.configinfo.OneSceneinfo);
    this.OneSceneinfo = this.$store.state.configinfo.OneSceneinfo;

    // if (this.$store.state.configinfo.OneSceneinfo === null) {
    //   console.log(this.$store.state.configinfo.OneSceneinfo);
    // } else {
    //     // 说明仓库里的场景信息  是有的
    //   this.OneSceneinfo = this.$store.state.configinfo.OneSceneinfo;
    // }
    /// 请求区域信息接口，获取数据
    // this.$request({
    //   method: "post",
    //   url: "/userScene/findUserSceneList",
    //   data: {
    //     token: this.$store.state.token
    //   }
    // })
    //   .then(res => {
    //     if (res.data.code != 0) {
    //       this.$showTipsToast(3, res.data.message);
    //       ////说明信息填写错误,控制失败了，
    //       return;
    //     } else {
    //       ////、控制成功了
    //       this.ServeSceneData = res.data.data; ////拿到服务器返回的数据结果
    //       // this.$showTipsToast(1, "获取成功", true); ////提示框
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error);
    //   });
  }
};
</script>

<style>
.config_add_scene_title_hang_height {
  height: 8px;
}
</style>